import DefaultLayout from "../components/layout/DefaultLayout";
function AboutUsPage() {
  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1" id="scrollToSection">
          <div className="container">
            <div className="section-title section-title--style-1 text-center mb-5">
              <h1 className="section-title-inner heading-sm strong-600 text-uppercase">
                <span>Mas acerca de nosotros..</span>
              </h1>
              <span className="section-title-delimiter clearfix d-none"></span>
            </div>
            <span className="clearfix"></span>

            <div className="fluid-paragraph fluid-paragraph-sm c-gray-light strong-300 text-center">
              Ser líderes en asesoría y desarrollo de soluciones inmobiliarias.
            </div>

            <span className="space-xs-md"></span>
          </div>
        </section>
        <section className="slice sct-color-1">
          <div className="container">
            <div className="row cols-xs-space cols-md-space cols-sm-space">
              <div className="col-lg-4">
                <div className="icon-block icon-block--style-2-v1 text-center">
                  <div className="block-icon circle bg-base-1">
                    <i className="ion-ios-heart"></i>
                  </div>
                  <h2 className="heading heading-5 strong-500">MISIÓN</h2>
                  <p className="px-4">
                    Ser líderes en asesoría y desarrollo de soluciones
                    inmobiliarias.
                  </p>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="icon-block icon-block--style-2-v1 text-center">
                  <div className="block-icon circle bg-base-1">
                    <i className="ion-ios-eye"></i>
                  </div>
                  <h2 className="heading heading-5 strong-500">VISIÓN</h2>
                  <p className="px-4">
                    Crecer como empresa integral y así establecernos como un
                    referente primordial de calidad y excelencia en el sector
                    inmobiliario.
                  </p>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="icon-block icon-block--style-2-v1 text-center">
                  <div className="block-icon circle bg-base-1">
                    <i className="ion-ios-book"></i>
                  </div>
                  <h2 className="heading heading-5 strong-500">Historia</h2>
                  <p className="px-4">
                    Desde 1983 prestamos el mejor servicio tanto a propietarios
                    como a arrendatarios, haciendo que muchos puedan encontrar
                    el lugar que tanto buscan para vivir sus sueños.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default AboutUsPage;
